// extracted by mini-css-extract-plugin
export var lightBlueBackground = "y_bF";
export var mortgageTrendsCustom = "y_bJ";
export var ratesTableWrapper = "y_bH";
export var sectionContainer = "y_bG";